import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { InstagramLogo, Sparkle, PaperPlaneTilt, X } from "@phosphor-icons/react";
import { toast } from "sonner";

const errMsg = (e) => e.response?.data?.detail || "Errore";

function DmCard({ dm, reload }) {
  const [text, setText] = useState(dm.ai_suggestion || "");
  const [busy, setBusy] = useState(false);
  const suggest = async () => {
    setBusy(true);
    try { const r = await api.post(`/ig/dms/${dm.id}/suggest`); setText(r.data.suggestion); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const send = async () => {
    setBusy(true);
    try { await api.post(`/ig/dms/${dm.id}/send`, { text }); toast.success("Risposta inviata su Instagram"); reload(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const dismiss = async () => { await api.post(`/ig/dms/${dm.id}/dismiss`); reload(); };
  return (
    <div className="rounded-xl border border-line p-4 space-y-2" data-testid={`dm-${dm.id}`}>
      <div className="text-[11px] uppercase tracking-widest text-stone">
        {dm.is_story_reply ? `Risposta alla storia${dm.story_hook ? `: "${dm.story_hook}"` : ""}` : "Messaggio diretto"} · {new Date(dm.created_at).toLocaleString("it-IT")}
      </div>
      <div className="text-ink">"{dm.text}"</div>
      <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="Risposta…" data-testid={`dm-reply-${dm.id}`} />
      <div className="flex flex-wrap gap-2">
        <Button size="sm" className="rounded-full bg-ink text-canvas" disabled={busy || !text.trim()} onClick={send} data-testid={`dm-send-${dm.id}`}><PaperPlaneTilt size={14} className="mr-1" />Invia</Button>
        <Button size="sm" variant="outline" className="rounded-full" disabled={busy} onClick={suggest} data-testid={`dm-suggest-${dm.id}`}><Sparkle size={14} className="mr-1" />{text ? "Rigenera" : "Suggerisci"}</Button>
        <Button size="sm" variant="ghost" className="rounded-full" onClick={dismiss} data-testid={`dm-dismiss-${dm.id}`}><X size={14} className="mr-1" />Ignora</Button>
      </div>
    </div>
  );
}

export default function StoryDMs() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/ig/dms").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  return (
    <div className="rounded-2xl border border-line bg-canvas p-5 space-y-3" data-testid="story-dms">
      <div className="font-serif text-lg text-ink flex items-center gap-2"><InstagramLogo size={20} />Risposte DM alle storie</div>
      {!items.length && <div className="text-sm text-stone" data-testid="story-dms-empty">Nessun messaggio da gestire. Quando qualcuno risponde a una storia, qui trovi la risposta AI pronta da inviare in un tocco.</div>}
      {items.map((dm) => <DmCard key={dm.id} dm={dm} reload={load} />)}
    </div>
  );
}
